import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './ResendInviteUserDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const RESEND_INVITE_USER_DIALOG = 'RESEND_INVITE_USER_DIALOG';

const ResendInviteUserDialog = ({ onResendCancel, onResend, usersCount = 0 }) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel_invite"
            automationName="cancel_invite"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onResendCancel}
        />,
        <ButtonStandard
            key="resend_invite"
            automationName="resend_invite"
            className={css.resendButton}
            value={formatMessage(Locale.resend)}
            onClick={onResend}
        />,
    ];

    return (
        <Dialog
            dialogId={RESEND_INVITE_USER_DIALOG}
            header={formatMessage(Locale.resendInvite)}
            buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={RESEND_INVITE_USER_DIALOG} />
                    <Label value={formatMessage(Locale.userResendConfirmation)} />
                    <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(ResendInviteUserDialog);
